/** Amazon retail marketplaces used when sourcing (buy link + currency symbol). */
export const BUY_MARKETPLACES = [
  { code: 'US', flag: '🇺🇸', currency: 'USD', symbol: '$', domain: 'amazon.com', label: 'United States' },
  { code: 'CA', flag: '🇨🇦', currency: 'CAD', symbol: 'C$', domain: 'amazon.ca', label: 'Canada' },
  { code: 'MX', flag: '🇲🇽', currency: 'MXN', symbol: 'MX$', domain: 'amazon.com.mx', label: 'Mexico' },
  { code: 'BR', flag: '🇧🇷', currency: 'BRL', symbol: 'R$', domain: 'amazon.com.br', label: 'Brazil' },
  { code: 'UK', flag: '🇬🇧', currency: 'GBP', symbol: '£', domain: 'amazon.co.uk', label: 'United Kingdom' },
  { code: 'DE', flag: '🇩🇪', currency: 'EUR', symbol: '€', domain: 'amazon.de', label: 'Germany' },
  { code: 'FR', flag: '🇫🇷', currency: 'EUR', symbol: '€', domain: 'amazon.fr', label: 'France' },
  { code: 'IT', flag: '🇮🇹', currency: 'EUR', symbol: '€', domain: 'amazon.it', label: 'Italy' },
  { code: 'ES', flag: '🇪🇸', currency: 'EUR', symbol: '€', domain: 'amazon.es', label: 'Spain' },
  { code: 'NL', flag: '🇳🇱', currency: 'EUR', symbol: '€', domain: 'amazon.nl', label: 'Netherlands' },
  { code: 'BE', flag: '🇧🇪', currency: 'EUR', symbol: '€', domain: 'amazon.com.be', label: 'Belgium' },
  { code: 'SE', flag: '🇸🇪', currency: 'SEK', symbol: 'kr', domain: 'amazon.se', label: 'Sweden' },
  { code: 'PL', flag: '🇵🇱', currency: 'PLN', symbol: 'zł', domain: 'amazon.pl', label: 'Poland' },
  { code: 'TR', flag: '🇹🇷', currency: 'TRY', symbol: '₺', domain: 'amazon.com.tr', label: 'Turkey' },
  { code: 'AE', flag: '🇦🇪', currency: 'AED', symbol: 'د.إ', domain: 'amazon.ae', label: 'United Arab Emirates' },
  { code: 'SA', flag: '🇸🇦', currency: 'SAR', symbol: '﷼', domain: 'amazon.sa', label: 'Saudi Arabia' },
  { code: 'EG', flag: '🇪🇬', currency: 'EGP', symbol: 'E£', domain: 'amazon.eg', label: 'Egypt' },
  { code: 'IN', flag: '🇮🇳', currency: 'INR', symbol: '₹', domain: 'amazon.in', label: 'India' },
  { code: 'SG', flag: '🇸🇬', currency: 'SGD', symbol: 'S$', domain: 'amazon.sg', label: 'Singapore' },
  { code: 'JP', flag: '🇯🇵', currency: 'JPY', symbol: '¥', domain: 'amazon.co.jp', label: 'Japan' },
  { code: 'AU', flag: '🇦🇺', currency: 'AUD', symbol: 'A$', domain: 'amazon.com.au', label: 'Australia' },
];

const BY_CODE = Object.fromEntries(BUY_MARKETPLACES.map((m) => [m.code, m]));

export function getBuyMarketplace(code) {
  const key = String(code || 'US').trim().toUpperCase();
  return BY_CODE[key] || BY_CODE.US;
}

export function amazonAsinUrl(asin, marketplaceCode) {
  if (!asin) return null;
  const market = getBuyMarketplace(marketplaceCode);
  return `https://www.${market.domain}/dp/${asin}`;
}

export function formatBuyMoney(amount, marketplaceCode) {
  const market = getBuyMarketplace(marketplaceCode);
  const value = Number(amount);
  if (!Number.isFinite(value)) return `${market.symbol}0.00`;
  return `${market.symbol}${value.toFixed(2)}`;
}
